import { useEffect, useState, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import DashboardMenu from '../components/DashboardMenu'
import MenuBar from '../components/MenuBar'
import Skeleton from '@mui/material/Skeleton';
import { Query, Client, Account } from 'appwrite'
import ThemeOption from '../components/ThemeOption'
import { UserSession, checkUser } from '../utils'
import { useAtom } from 'jotai'

import { PageContainer } from '@toolpad/core/PageContainer';
import Grid from '@mui/material/Grid2';
import { OutlinedCard } from '../components/OutlinedCard';
import LogoLoader from '../components/LogoLoader';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

const account = new Account(client);

var mountedLoad = false;


export default function _Main() {
    const navigate = useNavigate()
    const [userSession, setUserSession] = useAtom(UserSession);

    const [isLoading, setIsLoading] = useState(true);
    const [isVisible, setIsVisible] = useState(true);


    useEffect(() => {
        if (!mountedLoad) mountedLoad = true;
    }, []);

    // Set authenticated session on initial page load
    useEffect(() => {
        const checkSession = async () => {
            try {
                const user = await account.get()
                return user
            } catch (error) {
                navigate('/')
            }
        }
        setUserSession(checkSession())
    }, []);

    // Display loading screen while the page loads
    useLayoutEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsLoading(false);
            setTimeout(() => {
                setIsVisible(false);
            }, 750);
        }, 0);
        
        return () => clearTimeout(timeoutId);
    }, []);

    return (<>
        {/* User dashboard */}
        {userSession ? <>
            <DashboardMenu path="" user={userSession} page={<div className="page-content">
                <h1>Dashboard</h1>
                <h3>Welcome back, {userSession.name}</h3>
                <br/>
                <p><i>Nothing here yet...</i></p>
                {/* <Grid container spacing={1}>
                    <Grid size={12}>
                        <OutlinedCard />
                    </Grid>
                    <Grid size={12}>
                        <OutlinedCard />
                    </Grid>
                    <Grid size={4}>
                        <OutlinedCard />
                    </Grid>
                    <Grid size={8}>
                        <OutlinedCard />
                    </Grid>
                </Grid> */}
            </div>} />

            {isVisible && !mountedLoad && (<div className={`logo-loader ${!isLoading ? 'hidden' : ''}`}>
                <LogoLoader />
            </div>)}
        </> :
        
        // Main homepage
        <>
            <MenuBar page={<div className="page-content">
                <br/>
                <h1>Simplify your takeoff process</h1>
                <br/>
                <h2 id="about">About</h2>
                <br/>
                <h2 id="pricing">Pricing</h2>
                <br/>
                <h2 id="contact">Contact</h2>
            </div>}/>
        </>}
    </>)
}